// extracted by mini-css-extract-plugin
export var button = "_bs-7";
export var buttonRow = "_bs-6";
export var fadeIn = "_bs-1";
export var gradient = "_bs-0";
export var panel = "_bs-2";
export var panelIn = "_bs-3";
export var subtitle = "_bs-5";
export var title = "_bs-4";